import { generatePalette } from './generative-theme';
import { createDelugeTheme } from './theme-create';
import { darkPalette } from './theme-palette';
/**
 * The kol.trade yellow for a light background. Deeper than the dark theme's
 * `KOL_YELLOW`: accents here are also used as text, and a bright yellow on a
 * near-white page cannot be read.
 */
const { primary, primaryA } = generatePalette({
    appearance: 'light',
    appearanceColor: '#e0dfdf',
    primary: '#C99200',
});
const background = {
    [1]: '#dad9e0',
    [2]: '#d4d3d9',
    [3]: '#c9c7cf',
    [4]: '#bfbdc5',
    [5]: '#b5b4bb',
    [6]: '#ababac',
    [7]: '#9f9fa1',
    [8]: '#8b8a8f',
    [9]: '#5f5f61',
    [10]: '#565558',
    [11]: '#3c3b3d',
    [12]: '#202020',
};
const backgroundA = {
    [1]: '#2120ff08',
    [2]: '#0605720e',
    [3]: '#0f044d1c',
    [4]: '#09013527',
    [5]: '#05042832',
    [6]: '#03060a3d',
    [7]: '#01030a4a',
    [8]: '#03020f62',
    [9]: '#00010593',
    [10]: '#0200059e',
    [11]: '#020003bc',
    [12]: '#000101db',
};
const text = {
    [1]: '#dadada',
    [2]: '#d4d4d4',
    [3]: '#c9c8c8',
    [4]: '#bfbebe',
    [5]: '#b6b5b5',
    [6]: '#ababab',
    [7]: '#9f9f9f',
    [8]: '#8b8b8b',
    [9]: '#5f5f5f',
    [10]: '#565555',
    [11]: '#3c3b3b',
    [12]: '#202020',
};
const textA = {
    [1]: '#06292907',
    [2]: '#0617170e',
    [3]: '#0706061b',
    [4]: '#03020226',
    [5]: '#06050531',
    [6]: '#0306063d',
    [7]: '#0103034a',
    [8]: '#01030361',
    [9]: '#00010193',
    [10]: '#0200009e',
    [11]: '#020000bc',
    [12]: '#000101db',
};
const teal = {
    [1]: '#d8dcdb',
    [2]: '#ced6d4',
    [3]: '#bbd0ca',
    [4]: '#a7c9bf',
    [5]: '#91beb2',
    [6]: '#78b1a2',
    [7]: '#569f8e',
    [8]: '#0e8a75',
    [9]: '#039881',
    [10]: '#0c8975',
    [11]: '#005141',
    [12]: '#163c34',
};
const tealA = {
    [1]: '#14937a0a',
    [2]: '#06725a15',
    [3]: '#0587632b',
    [4]: '#01896241',
    [5]: '#0182605a',
    [6]: '#027d5d77',
    [7]: '#02785c9e',
    [8]: '#01856ff0',
    [9]: '#009780fc',
    [10]: '#018570f2',
    [11]: '#005141',
    [12]: '#002a21e6',
};
const green = {
    [1]: '#d8dcd7',
    [2]: '#cfd7cf',
    [3]: '#bed1bd',
    [4]: '#accaa9',
    [5]: '#96c192',
    [6]: '#7ab577',
    [7]: '#55a551',
    [8]: '#008f00',
    [9]: '#00b112',
    [10]: '#00a400',
    [11]: '#005300',
    [12]: '#173f16',
};
const greenA = {
    [1]: '#1493140a',
    [2]: '#08791314',
    [3]: '#02840127',
    [4]: '#0a89013e',
    [5]: '#0c8a0359',
    [6]: '#06850177',
    [7]: '#078501a3',
    [8]: '#008f00',
    [9]: '#00b112',
    [10]: '#00a400',
    [11]: '#005300',
    [12]: '#012e00e6',
};
const red = {
    [1]: '#dddad9',
    [2]: '#dbd2d2',
    [3]: '#d9c4c2',
    [4]: '#dfb1ae',
    [5]: '#dba09d',
    [6]: '#d38e8b',
    [7]: '#c87875',
    [8]: '#be5b59',
    [9]: '#ee3544',
    [10]: '#df2138',
    [11]: '#940012',
    [12]: '#690e17',
};
const redA = {
    [1]: '#73290507',
    [2]: '#8c03030f',
    [3]: '#ac150622',
    [4]: '#dc120439',
    [5]: '#d00b014c',
    [6]: '#be0b0361',
    [7]: '#ae08027a',
    [8]: '#a805029a',
    [9]: '#ff000074',
    [10]: '#de011cda',
    [11]: '#940012',
    [12]: '#61000aef',
};
const downAccentRed = {
    [1]: '#dddad9',
    [2]: '#dcd2d1',
    [3]: '#dbc3c1',
    [4]: '#e3afac',
    [5]: '#e09e9a',
    [6]: '#d98b87',
    [7]: '#cf7471',
    [8]: '#c65454',
    [9]: '#ff113c',
    [10]: '#f0002f',
    [11]: '#940013',
    [12]: '#6f0011',
};
const downAccentRedA = {
    [1]: '#73290507',
    [2]: '#a51d0e11',
    [3]: '#bc130523',
    [4]: '#ff000019',
    [5]: '#e00e014f',
    [6]: '#cf0b0165',
    [7]: '#be07017e',
    [8]: '#b700009f',
    [9]: '#ff113c',
    [10]: '#ff000084',
    [11]: '#940013',
    [12]: '#6f0011',
};
const neutral = {
    [1]: '#dadada',
    [2]: '#d4d4d4',
    [3]: '#c8c8c8',
    [4]: '#bebebe',
    [5]: '#b5b5b5',
    [6]: '#ababab',
    [7]: '#9e9e9e',
    [8]: '#8a8a8a',
    [9]: '#6e6e6e',
    [10]: '#616161',
    [11]: '#3c3c3c',
    [12]: '#212121',
};
const neutralA = {
    [1]: '#06292907',
    [2]: '#0617170e',
    [3]: '#060d0d1c',
    [4]: '#02080827',
    [5]: '#01050531',
    [6]: '#0306063d',
    [7]: '#0305054c',
    [8]: '#01020262',
    [9]: '#00020282',
    [10]: '#00020291',
    [11]: '#000101bb',
    [12]: '#000101da',
};
const neutralAccent = {
    [1]: '#dbdbdb',
    [2]: '#d4d4d4',
    [3]: '#c9c9c9',
    [4]: '#bfbfbf',
    [5]: '#b6b6b6',
    [6]: '#acacac',
    [7]: '#a0a0a0',
    [8]: '#8b8b8b',
    [9]: '#535353',
    [10]: '#444444',
    [11]: '#3a3a3a',
    [12]: '#202020',
};
const neutralAccentA = {
    [1]: '#0c363606',
    [2]: '#0617170e',
    [3]: '#0710101b',
    [4]: '#03090926',
    [5]: '#01060630',
    [6]: '#0406063c',
    [7]: '#01030349',
    [8]: '#01030361',
    [9]: '#000202a1',
    [10]: '#000101b2',
    [11]: '#000000bd',
    [12]: '#000101db',
};
const yellow = {
    [1]: '#dcdbd9',
    [2]: '#ddd5c6',
    [3]: '#e3cb9d',
    [4]: '#e2bf78',
    [5]: '#deb252',
    [6]: '#cda44c',
    [7]: '#b9923d',
    [8]: '#a67a00',
    [9]: '#d29700',
    [10]: '#c48c00',
    [11]: '#684700',
    [12]: '#463a20',
};
const yellowA = {
    [1]: '#4f4e0507',
    [2]: '#c588041d',
    [3]: '#ff130019',
    [4]: '#ff000011',
    [5]: '#dd9902a2',
    [6]: '#c38602a9',
    [7]: '#aa7601ba',
    [8]: '#a67a00',
    [9]: '#d29700',
    [10]: '#c48c00',
    [11]: '#684700',
    [12]: '#2c1f01db',
};
const orange = {
    [1]: '#dcdad9',
    [2]: '#dad2ce',
    [3]: '#d9c5bb',
    [4]: '#dcb29d',
    [5]: '#d9a286',
    [6]: '#ce9375',
    [7]: '#be805f',
    [8]: '#b16840',
    [9]: '#ab3e00',
    [10]: '#963400',
    [11]: '#8b2e00',
    [12]: '#542f1b',
};
const orangeA = {
    [1]: '#4f290507',
    [2]: '#94390614',
    [3]: '#b642052a',
    [4]: '#d348014c',
    [5]: '#cf470166',
    [6]: '#bb41027a',
    [7]: '#a53b0193',
    [8]: '#9f3800b6',
    [9]: '#ab3e00',
    [10]: '#963400',
    [11]: '#8b2e00',
    [12]: '#421801e1',
};
const silver = {
    [1]: '#dadada',
    [2]: '#d4d4d4',
    [3]: '#c9c9c9',
    [4]: '#bfbfbf',
    [5]: '#b5b5b5',
    [6]: '#ababab',
    [7]: '#9e9e9e',
    [8]: '#8a8a8a',
    [9]: '#5e5e5e',
    [10]: '#505050',
    [11]: '#3b3b3b',
    [12]: '#212121',
};
const silverA = {
    [1]: '#06292907',
    [2]: '#0617170e',
    [3]: '#0710101b',
    [4]: '#03090926',
    [5]: '#01050531',
    [6]: '#0306063d',
    [7]: '#0305054c',
    [8]: '#01020262',
    [9]: '#00000094',
    [10]: '#000000a4',
    [11]: '#000000bc',
    [12]: '#000101da',
};
const golden = {
    [1]: '#dbdbd8',
    [2]: '#dcd6c4',
    [3]: '#e1cd95',
    [4]: '#e0c16c',
    [5]: '#dcb43e',
    [6]: '#cba639',
    [7]: '#b7942b',
    [8]: '#a37c00',
    [9]: '#cd9e00',
    [10]: '#bf9300',
    [11]: '#644900',
    [12]: '#453a1d',
};
const goldenA = {
    [1]: '#536e1909',
    [2]: '#c095011f',
    [3]: '#fd000009',
    [4]: '#e0a50084',
    [5]: '#dba402b9',
    [6]: '#c49200be',
    [7]: '#ad8200ce',
    [8]: '#a37c00',
    [9]: '#cd9e00',
    [10]: '#bf9300',
    [11]: '#644900',
    [12]: '#2e2100de',
};
const successGreen = {
    [1]: '#d9dcda',
    [2]: '#d0d6d2',
    [3]: '#bfcfc5',
    [4]: '#adc7b6',
    [5]: '#99bda7',
    [6]: '#81b094',
    [7]: '#619f7b',
    [8]: '#2b885a',
    [9]: '#30a46c',
    [10]: '#3a9466',
    [11]: '#005328',
    [12]: '#1d3b2a',
};
const successGreenA = {
    [1]: '#01804008',
    [2]: '#0a673113',
    [3]: '#03743126',
    [4]: '#04782e3b',
    [5]: '#01742f51',
    [6]: '#02712f6d',
    [7]: '#006f3091',
    [8]: '#01743bcf',
    [9]: '#01954ec9',
    [10]: '#007a3cbd',
    [11]: '#005328',
    [12]: '#00230fde',
};
const successAccentGray = {
    [1]: '#dadadb',
    [2]: '#d4d4d5',
    [3]: '#c9c9ca',
    [4]: '#bfbfc0',
    [5]: '#b5b5b7',
    [6]: '#acacad',
    [7]: '#9f9fa1',
    [8]: '#8b8b8d',
    [9]: '#5e5e61',
    [10]: '#545457',
    [11]: '#3a3a3c',
    [12]: '#202021',
};
const successAccentGrayA = {
    [1]: '#06294e07',
    [2]: '#0617290e',
    [3]: '#0710191b',
    [4]: '#03090f26',
    [5]: '#01050f31',
    [6]: '#04060a3c',
    [7]: '#01030a4a',
    [8]: '#01030861',
    [9]: '#00000694',
    [10]: '#010207a0',
    [11]: '#000003bd',
    [12]: '#000102db',
};
const errorRed = {
    [1]: '#dddada',
    [2]: '#dad3d3',
    [3]: '#d7c3c4',
    [4]: '#d8b3b6',
    [5]: '#d2a4a8',
    [6]: '#c99398',
    [7]: '#be7f85',
    [8]: '#b3646d',
    [9]: '#e54666',
    [10]: '#d6375a',
    [11]: '#8e002b',
    [12]: '#651727',
};
const errorRedA = {
    [1]: '#610b0b06',
    [2]: '#7305050e',
    [3]: '#9b070f21',
    [4]: '#b8031233',
    [5]: '#ac011044',
    [6]: '#9c010f57',
    [7]: '#92010f6e',
    [8]: '#8f00118d',
    [9]: '#ff00002a',
    [10]: '#d30130c1',
    [11]: '#8e002b',
    [12]: '#570012e5',
};
const lime = {
    [1]: '#dadbd7',
    [2]: '#d4d8c8',
    [3]: '#c9d59d',
    [4]: '#becd7c',
    [5]: '#b1c35d',
    [6]: '#a2b24e',
    [7]: '#91a043',
    [8]: '#7a8a06',
    [9]: '#a8be00',
    [10]: '#9db300',
    [11]: '#485300',
    [12]: '#3a4020',
};
const limeA = {
    [1]: '#477a140a',
    [2]: '#6f9d061b',
    [3]: '#93bd014c',
    [4]: '#94b70272',
    [5]: '#90af0095',
    [6]: '#819a00a6',
    [7]: '#6f8601b3',
    [8]: '#788801f9',
    [9]: '#a8be00',
    [10]: '#9db300',
    [11]: '#485300',
    [12]: '#1e2601db',
};
const boostGreen = {
    [1]: '#d8dcd8',
    [2]: '#cfd7cf',
    [3]: '#b6d4b6',
    [4]: '#9ece9f',
    [5]: '#86c587',
    [6]: '#6bb76f',
    [7]: '#49a651',
    [8]: '#00911a',
    [9]: '#00e040',
    [10]: '#00d532',
    [11]: '#005700',
    [12]: '#1a441d',
};
const boostGreenA = {
    [1]: '#14932d0a',
    [2]: '#08791314',
    [3]: '#01a50630',
    [4]: '#03a6084c',
    [5]: '#019f0667',
    [6]: '#02930a86',
    [7]: '#008a0cac',
    [8]: '#00911a',
    [9]: '#00ff0008',
    [10]: '#00d532',
    [11]: '#005700',
    [12]: '#013105e2',
};
const boostIconGreen = {
    [1]: '#d9dcd9',
    [2]: '#d1d6d1',
    [3]: '#c2cfc3',
    [4]: '#b1c7b4',
    [5]: '#9ebda2',
    [6]: '#87b08c',
    [7]: '#689f71',
    [8]: '#38894b',
    [9]: '#1a6f33',
    [10]: '#00611f',
    [11]: '#005216',
    [12]: '#213c26',
};
const boostIconGreenA = {
    [1]: '#01802008',
    [2]: '#0c601912',
    [3]: '#066b1323',
    [4]: '#026e1436',
    [5]: '#036d124c',
    [6]: '#026a1066',
    [7]: '#00681389',
    [8]: '#016d1bc0',
    [9]: '#01611de2',
    [10]: '#00611f',
    [11]: '#005216',
    [12]: '#002107da',
};
const boostGlowGreen = {
    [1]: '#d8dcd8',
    [2]: '#cfd7cf',
    [3]: '#b5d5b5',
    [4]: '#9ccf9d',
    [5]: '#83c586',
    [6]: '#69b86e',
    [7]: '#48a651',
    [8]: '#00911e',
    [9]: '#00e645',
    [10]: '#00db37',
    [11]: '#005800',
    [12]: '#1b441e',
};
const boostGlowGreenA = {
    [1]: '#14932d0a',
    [2]: '#08791314',
    [3]: '#01ab0531',
    [4]: '#02ab084e',
    [5]: '#01a1096a',
    [6]: '#00960c88',
    [7]: '#028b0fae',
    [8]: '#00911e',
    [9]: '#00ff0038',
    [10]: '#00db37',
    [11]: '#005800',
    [12]: '#013005e1',
};
const boostButtonGreen = {
    [1]: '#d8dbd8',
    [2]: '#d0d7ce',
    [3]: '#b7d5b1',
    [4]: '#a0cf95',
    [5]: '#89c57c',
    [6]: '#71b762',
    [7]: '#55a442',
    [8]: '#229000',
    [9]: '#49e600',
    [10]: '#3adb00',
    [11]: '#005700',
    [12]: '#214419',
};
const boostButtonGreenA = {
    [1]: '#147a2d0a',
    [2]: '#14790614',
    [3]: '#1baf0235',
    [4]: '#20af0155',
    [5]: '#1ea50272',
    [6]: '#1b98008f',
    [7]: '#1b8b00b4',
    [8]: '#229000',
    [9]: '#00ff0038',
    [10]: '#3adb00',
    [11]: '#005700',
    [12]: '#093101e3',
};
const subscriptionViolet = {
    [1]: '#dadadc',
    [2]: '#d5d3db',
    [3]: '#ccc9d9',
    [4]: '#c2bbda',
    [5]: '#b6acd9',
    [6]: '#a99bd4',
    [7]: '#9684ca',
    [8]: '#8066c1',
    [9]: '#5308a2',
    [10]: '#6328b7',
    [11]: '#4a0e91',
    [12]: '#382064',
};
const subscriptionVioletA = {
    [1]: '#06297207',
    [2]: '#1805970e',
    [3]: '#1c08a51a',
    [4]: '#2a05c12a',
    [5]: '#2b03c63b',
    [6]: '#2d01bb4e',
    [7]: '#2c02ac69',
    [8]: '#3002a88b',
    [9]: '#4e00a0f6',
    [10]: '#4801afd2',
    [11]: '#40008cef',
    [12]: '#1c0150db',
};
const subscriptionBlue = {
    [1]: '#dadadc',
    [2]: '#d2d4db',
    [3]: '#c7cad8',
    [4]: '#b9c0d9',
    [5]: '#aab2d7',
    [6]: '#98a2d2',
    [7]: '#828ec9',
    [8]: '#6673c0',
    [9]: '#6977fd',
    [10]: '#5e6aef',
    [11]: '#302da8',
    [12]: '#262c63',
};
const subscriptionBlueA = {
    [1]: '#06297207',
    [2]: '#0130a010',
    [3]: '#0427a21d',
    [4]: '#0430bd2d',
    [5]: '#0226bf3e',
    [6]: '#0122b752',
    [7]: '#031fab6c',
    [8]: '#0019a78b',
    [9]: '#6271fff0',
    [10]: '#0000ff80',
    [11]: '#04009acc',
    [12]: '#000749d4',
};
const subscriptionIconBlue = {
    [1]: '#dadbdd',
    [2]: '#d1d4dc',
    [3]: '#c6cada',
    [4]: '#b7c0dd',
    [5]: '#a7b2de',
    [6]: '#94a2da',
    [7]: '#7d8ed3',
    [8]: '#5f71ce',
    [9]: '#2c367e',
    [10]: '#353db2',
    [11]: '#2f3991',
    [12]: '#21286f',
};
const subscriptionIconBlueA = {
    [1]: '#064e9707',
    [2]: '#0c44b512',
    [3]: '#042db51e',
    [4]: '#0237d52f',
    [5]: '#012fdc41',
    [6]: '#012dd157',
    [7]: '#0129c471',
    [8]: '#0021c293',
    [9]: '#000d66cd',
    [10]: '#000ca5c3',
    [11]: '#000e7dca',
    [12]: '#00095cda',
};
const subscriptionGlowViolet = {
    [1]: '#dadadc',
    [2]: '#d3d4dc',
    [3]: '#cacada',
    [4]: '#bcbcdd',
    [5]: '#afafde',
    [6]: '#a09eda',
    [7]: '#8b88d1',
    [8]: '#7269c9',
    [9]: '#7e66ff',
    [10]: '#7358f0',
    [11]: '#3d109c',
    [12]: '#2e2269',
};
const subscriptionGlowVioletA = {
    [1]: '#06297207',
    [2]: '#0425ad0f',
    [3]: '#0912ae1a',
    [4]: '#0106d329',
    [5]: '#0105db38',
    [6]: '#0703ce4b',
    [7]: '#0801bb64',
    [8]: '#1100b687',
    [9]: '#7e66ff',
    [10]: '#1400ff88',
    [11]: '#300097ed',
    [12]: '#0f0155d9',
};
const subscriptionButtonViolet = {
    [1]: '#dadadd',
    [2]: '#d4d4db',
    [3]: '#cac9db',
    [4]: '#bebbdd',
    [5]: '#b2addc',
    [6]: '#a39cd8',
    [7]: '#9086cf',
    [8]: '#7868c7',
    [9]: '#8a68ff',
    [10]: '#7e5af1',
    [11]: '#430d9a',
    [12]: '#332169',
};
const subscriptionButtonVioletA = {
    [1]: '#06299707',
    [2]: '#0617970e',
    [3]: '#0908b81a',
    [4]: '#1205d32a',
    [5]: '#1604d23a',
    [6]: '#1601c84d',
    [7]: '#1801b766',
    [8]: '#1e02b389',
    [9]: '#8a68ff',
    [10]: '#3300ff90',
    [11]: '#3a0196f1',
    [12]: '#150155da',
};
export const delugeLightTheme = createDelugeTheme({
    appearance: 'light',
    appearanceColor: '#e0dfdf',
    palette: {
        ...darkPalette,
        primary,
        primaryA,
        background,
        backgroundA,
        text,
        textA,
        green: teal,
        up: teal,
        upA: tealA,
        upAccent: green,
        upAccentA: greenA,
        red,
        down: red,
        downA: redA,
        downAccent: downAccentRed,
        downAccentA: downAccentRedA,
        neutral,
        neutralA,
        neutralAccent,
        neutralAccentA,
        candleGreen: teal,
        candleGreenBorder: teal,
        candleGreenWick: teal,
        candleGreenA: tealA,
        candleGreenBorderA: tealA,
        candleGreenWickA: tealA,
        candleRed: red,
        candleRedBorder: red,
        candleRedWick: red,
        candleRedA: redA,
        candleRedBorderA: redA,
        candleRedWickA: redA,
        amber: yellow,
        warning: yellow,
        warningA: yellowA,
        orange,
        warningAccent: orange,
        warningAccentA: orangeA,
        bronze: orange,
        bronzeA: orangeA,
        silver,
        silverA,
        golden,
        goldenA,
        success: successGreen,
        successA: successGreenA,
        successAccent: successAccentGray,
        successAccentA: successAccentGrayA,
        error: errorRed,
        errorA: errorRedA,
        errorAccent: downAccentRed,
        errorAccentA: downAccentRedA,
        boostGradientFrom: lime,
        boostGradientFromA: limeA,
        boostGradientTo: boostGreen,
        boostGradientToA: boostGreenA,
        boostIcon: boostIconGreen,
        boostIconA: boostIconGreenA,
        boostGlow: boostGlowGreen,
        boostGlowA: boostGlowGreenA,
        boostButton: boostButtonGreen,
        boostButtonA: boostButtonGreenA,
        subscriptionGradientFrom: subscriptionViolet,
        subscriptionGradientFromA: subscriptionVioletA,
        subscriptionGradientTo: subscriptionBlue,
        subscriptionGradientToA: subscriptionBlueA,
        subscriptionIcon: subscriptionIconBlue,
        subscriptionIconA: subscriptionIconBlueA,
        subscriptionGlow: subscriptionGlowViolet,
        subscriptionGlowA: subscriptionGlowVioletA,
        subscriptionButton: subscriptionButtonViolet,
        subscriptionButtonA: subscriptionButtonVioletA,
    },
    fontFamily: `"Inter", sans-serif;`,
});
//# sourceMappingURL=deluge-light-theme.js.map